import React, { useEffect, useRef, useState } from "react";
import StaticTypeWriterWithParser from "./StatictTypeWritingEffect/StaticTypeWriterWithParser";
import StaticTypeWriter from "./StatictTypeWritingEffect/StaticTypeWriter";
import ReactPlayer from "react-player";
import StaticFooter from "./StaticFooter";
import { staticHeader } from "../../Services/CommonServices/helper";

function PoloBear() {
  const [isTitle, setIsTitle] = useState(false);
  const [isContent, setIsContent] = useState(false);
  const [isContentTwo, setIsContentTwo] = useState(false);
  const [isContentThree, setIsContentThree] = useState(false);
  const [isContentFour, setIsContentFour] = useState(false);
  const [isFooter, setIsFooter] = useState(false);
  const [downArrow, setShowDownArrow] = useState(false);
  const effects = false;
  const titleHeader = "The best- dressed bear in the world";
  const subheader = "The inside story of iconic Polo Bear";
  const effectRan = useRef(false);

  useEffect(() => {
    if (!effectRan.current) {
      staticHeader(titleHeader, "titleHeader");
    }
    staticHeader(subheader, "subHeaderContainer");
    return () => (effectRan.current = true);
  }, [isTitle]);

  // scroll to bottom arrow functionality
  useEffect(() => {
    const pageContainer = document.getElementById('styleGuidePageContainer');
    if (!pageContainer) return;

    let initialViewportHeight = pageContainer.clientHeight;
    const handleScroll = () => {
      const overflownspace = pageContainer.scrollHeight - pageContainer.scrollTop - pageContainer.clientHeight;      
      if (overflownspace > initialViewportHeight * 0.1) {        
        setShowDownArrow(true);
      } else {
        setShowDownArrow(false);
      }
      return;
    };

    const observer = new MutationObserver(() => {
      setTimeout(handleScroll, 100);
    });
    observer.observe(pageContainer, { childList: true, subtree: true });
    pageContainer.addEventListener('scroll', handleScroll);
    handleScroll();
    setTimeout(handleScroll, 300);
    return () => {
      pageContainer.removeEventListener('scroll', handleScroll);
      setShowDownArrow(false);
      observer.disconnect();
    }
  }, [isContent, isContentTwo, isContentThree, isContentFour, isFooter]);

  const scrollToEnd = () => {
    const pageContainer = document.getElementById('styleGuidePageContainer');
    if (pageContainer) {
      pageContainer.scrollTo({
        top: pageContainer.scrollHeight - 100,
        behavior: 'smooth'
      });
      setShowDownArrow(false);
    }
  };

  const adjustDownArrowPosition = () => {
    const downArrowElement = document.querySelector('.down-arrow');

    if (downArrowElement) {
      downArrowElement.style.bottom = '15px';
      downArrowElement.style.left = '50%';
      downArrowElement.style.transform = 'translateX(-50%)';
    }
  };

  useEffect(() => {
    adjustDownArrowPosition();
    
    const handleResize = () => {
      adjustDownArrowPosition();
    };

    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [downArrow]);

  return (

    // Static Component without json data
    <div
      className="container p-0 art-of-bundling-up overflow"
      style={{ backgroundColor: "#EFEFEF" }}
      id="styleGuidePageContainer"
    >
      <div>
        <img
          src="/static/assets/StaticLandingPageImages/PoloBear-topimg.png"
          alt="top-img"
          className="top-img"
        />
      </div>
      <div className="content card align-items-center mb-0">
        <div className="title" id="titleHeader">
          <div style={{ display: "none" }}>
            <StaticTypeWriter
              text={"The best- dressed bear in the world"}
              setLoading={setIsTitle}
            />
          </div>
        </div>
        {isTitle && (
          <div className="subheader" id="subHeaderContainer">
            <div style={{ display: "none" }}>
              <StaticTypeWriter
                text={"The inside story of iconic Polo Bear"}
                setLoading={() => {}}
              />
            </div>
          </div>
        )}
        <div className="">
          {/* {isSubHeader && ( */}
            <div className="description carousel-polar-div">
              <StaticTypeWriterWithParser
                text={`<p>
                  He is a man of contradictions. Innocent yet sophisticated. Suave yet
                  cuddly. A beloved children’s toy … who enjoys an occasional martini.
                  He’s been spotted hobnobbing with international celebrities, written
                  about in leading newspapers, and even played a critical role in
                  shaping the cover of a seminal hip-hop record. He is, of course, the
                  Polo Bear, and this is his story.
                </p>
                <p>
                  The story begins not in 1991, when the Polo Bear made his debut, but
                  in 1902, when President Theodore Roosevelt went on a bear hunt in
                  Mississippi. At the end of the excursion, Roosevelt had failed to
                  fell his quarry, and an enterprising companion endeavored to tie a
                  bear to a tree and let the president shoot it. Roosevelt declined,
                  deeming the situation unsportsmanlike. Soon after, The Washington
                  Post ran a cartoon of the president sparing the bear’s life, which
                  inspired toy sellers to name stuffed bears after him. One maker of
                  those stuffed bears? A German gentleman by the name of Richard
                  Steiff; 122 years later, Steiff is the world’s most renowned maker
                  of teddy bears.
                </p>`}
                effects={effects}
                setLoading={setIsContent}
              />
              {isContent && (
                <ReactPlayer
                  className="polo-product-img"
                  url="https://rl-video.ralphlauren.com/v2/2024/10/20241024-homepage/RL_Holiday_Train_Bear_001_16x9_2.mp4"
                  playing
                  loop
                  width="100%"
                  height="auto"
                  controls
                  playsinline
                />
              )}
            </div>
          {/* )} */}
        </div>
      </div>
      {isContent && (
        <div className="carousel-polar-div">
          <img
            src="/static/assets/StaticLandingPageImages/Polo-img2.png"
            alt="img"
            className="polo_img"
          />
          <div className="content card align-items-center">
            <div style={{ marginBottom: "30px" }}>
              <img
                src="/static/assets/StaticLandingPageImages/Polo-img3.png"
                alt="img"
              />
            </div>
            <div className="description carousel-polar-div">
              <StaticTypeWriterWithParser
                text={`<p>
                Jerry Lauren, Ralph Lauren’s brother, who serves as senior
                consultant, men’s design, is a passionate collector of Steiff bears.
                (He’s estimated his collection to be at 30 to 40 bears, including
                around six that he keeps on his bed.) In 1990, inspired by his
                collection, Jerry’s colleagues had a Steiff bear dressed in Jerry’s
                likeness—blue oxford shirt, tartan tie, cable-knit sweater—and
                presented it to him for his birthday. At the same time, a
                Western-inspired bear was presented to Ralph. (Upon seeing the two
                bears, as Jerry recalls, Ralph remarked, “You know what? I’m a
                preppy, too.”) A tradition was born, and every year both Ralph and
                Jerry were given a Steiff bear. The bears—inspired by Ralph’s
                personal style—wore clothes often made in the same factories as
                actual Ralph Lauren clothing. “They’re always his favorite gift,”
                Jerry says.
              </p>
              <p>
                As with so much in the World of Ralph Lauren, what appealed to Ralph
                in his own life made its way to the clothes, and in 1991 the Polo
                Bear appeared in two very different forms. The first was an actual
                teddy bear (“Preppy Bear”), produced in tandem with Steiff, and
                massively popular from the start. The teddy bears, in a limited run
                of 200, sold out of the Madison Avenue flagship in one weekend. The
                second iteration of the bear was as an icon that eventually appeared
                on everything from T-shirts and denim jackets to dress shirts and
                ties.
              </p>
              <p>
                No matter where the Polo Bear roams, he remains beloved—a whimsical,
                just slightly mysterious complement to our iconic signature Pony.
                After all, as Jerry Lauren says, “Who doesn’t love a teddy bear?”
              </p>
              <p>
                The next year, a Polo Bear wearing an American flag sweater was
                hand-knit onto a Polo Ralph Lauren sweater, which was available in
                red or navy. The sweaters went quickly, and inspired a range of more
                bear products later that year. You could get a turtleneck with
                Martini Bear, holiday sweaters with intarsia-knit skiing bears, or a
                crewneck sweater with an intarsia-knit golfing bear wearing a Fair
                Isle sweater vest, considered by its designers to be the most
                elaborate bear they ever produced.
              </p>
              <p>
                Over the next several years, the Polo Bear appeared in a series of
                national ad campaigns (see above), while Steiff produced 19 mostly
                limited-edition teddy bears “dressed in clothes that I wear,” as
                Ralph said in 2001. “The same materials, the same craftsmanship,
                right down to the last detail.” (Not for nothing did one ad call him
                “the world’s best-dressed bear.”) Also available were a handful of
                female bears—like Safari Bear, wearing a Collection look from the
                Spring 1997 Runway Show, in which Naomi Campbell famously walked.
              </p>`}
                effects={effects}
                setLoading={setIsContentTwo}
              />
              {isContentTwo && (
                <div>
                  <div className="d-flex justify-content-center align-items-center">
                    <img
                      src="/static/assets/StaticLandingPageImages/Polo-img4.png"
                      alt="img"
                      className="polo-img4"
                    />
                  </div>
                  <StaticTypeWriterWithParser
                    text={`<p>
                    
                    The collaboration with Steiff ended in 2001, and production of the
                    special-edition sweaters was pulled back around the same time. But
                    during the past few years, the Polo Bear has returned, popping up
                    everywhere from the US Open, where you could have the bear, wearing
                    the official ballboy uniform, customized with your name and printed
                    onto a Polo shirt, to a version on John Mayer. In 2017, he even made
                    his Purple Label debut, appearing on the Italian-made Western Bear
                    sweatshirt, followed by an appearance on a grey sweater, himself
                    wearing a cricket sweater and toggle coat. (A 2017 camel coat
                    offered further homage—it was crafted using the same fabric Steiff
                    used for the original bears.)
                    </p>
                    <p>
                    The story continued into 2019, as the Collegiate Bear made his debut
                    on a Polo sweater. He beat out three other bears—none of whom had
                    ever appeared on a sweater—in the first-ever Polo Bear vote on the
                    former Polo App (now part of The Ralph Lauren App, which you can
                    download now from the App Store or Google Play). Soon afterward came
                    the Polo Bear watch collection, created in celebration of Ralph
                    Lauren’s 50th anniversary. The limited-run, Swiss-made collection
                    consisted of four models, each emblazoned with a different Polo
                    Bear, and each embodying a different take on Polo style: Preppy
                    Bear, Martini Bear, Flag Bear, and Spectator Bear. And, as a nod to
                    Ralph Lauren’s original design—the necktie—each watch comes with an
                    extra strap made with necktie silk, alongside a strap of French
                    calfskin or exotic alligator.
                    </p>`}
                    effects={effects}
                    setLoading={setIsContentThree}
                  />
                </div>
              )}
              {isContentThree && (
                <div>
                  <div className="d-flex justify-content-center align-items-center">
                    <img
                      src="/static/assets/StaticLandingPageImages/Polo-img5.png"
                      alt="img"
                      className="polo-img5"
                    />
                  </div>
                  <div className="polo-txt">
                    <StaticTypeWriterWithParser
                      text={`<p>
                        2021 brought two more milestones: The Polo Bear’s callup to “The
                        Show,” as part of a collaboration with Major League Baseball. Ever
                        the journeyman, the Polo Bear sported team-themed gear for the
                        Yankees™, Cubs™, Dodgers™, and Cardinals™. That year, the Polo
                        Bear also hopped aboard seven limited-edition skate decks, in
                        seven different incarnations, as part of the 2021 holiday
                        campaign.
                        </p>
                        <p>
                        This season, if you missed out on grabbing your favorite sweater
                        from seasons past, you’re in luck: A limited selection of 12
                        vintage Polo Bear sweaters will be available online through RL
                        Vintage. Some date back as far as 1992, and they feature a range
                        of Polo Bears: Preppy Bear, Skiing Bear, and the classic American
                        Flag bear.
                        </p>
                        <p>Needless to say, this is one bear with no time to hibernate.</p>`}
                      effects={effects}
                      setLoading={setIsContentFour}
                    />
                  </div>
                </div>
              )}
            </div>
            {isContentFour && (
              <div className="footer-txt">
                <StaticTypeWriter
                  text={`PAUL L. UNDERWOOD, is a writer based in Austin, Texas, and the former
                executive editor of RalphLauren.com.`}
                  setLoading={setIsFooter}
                />
              </div>
            )}
          </div>
        </div>
      )}

      {isFooter && <StaticFooter />}

      {downArrow && (
        <button
          className="down-arrow"
          onClick={scrollToEnd}
          style={{ 
            position: 'fixed',
            bottom: '44px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 1001,
            border: 'none',
            background: 'none',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <img
            alt="down-arrow"
            src="./static/assets/scrollDown.svg"
          />
        </button>
      )}
    </div>
  );
}

export default PoloBear;
